import { biasCls } from "@/lib/terminalUtils";

export const StructurePanel = ({ sig }) => {
  const mtf = sig?.mtf || {};
  return (
    <div className="border border-white/10 bg-[#0d1219] p-4" data-testid="structure-panel">
      <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-mute-dim">Structure (Multi-Timeframe)</p>
      <div className="mt-3 space-y-2.5 font-mono text-xs">
        {["4H", "1H", "15M", "5M"].map((tf) => (
          <div key={tf} className="flex items-center justify-between" data-testid={`mtf-${tf.toLowerCase()}`}>
            <span className="text-mute">{tf} {tf === "4H" ? "Bias" : "Structure"}</span>
            <span className={`font-bold ${biasCls(mtf[tf])}`}>{mtf[tf] || "…"}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export const LiquidityPanel = ({ sig }) => {
  const liq = sig?.liquidity || {};
  return (
    <div className="border border-white/10 bg-[#0d1219] p-4" data-testid="liquidity-panel">
      <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-mute-dim">Liquidity Zone</p>
      <div className="mt-3 space-y-2.5 font-mono text-xs">
        <div className="flex justify-between"><span className="text-mute">Buy Side (Above)</span><span className="font-bold text-buy">{liq.buy_side ?? "—"}</span></div>
        <div className="flex justify-between"><span className="text-mute">Sell Side (Below)</span><span className="font-bold text-sell">{liq.sell_side ?? "—"}</span></div>
        <div className="flex justify-between"><span className="text-mute">Strength (Above)</span><span className="text-buy">{liq.strength_above ?? "—"}</span></div>
        <div className="flex justify-between"><span className="text-mute">Strength (Below)</span><span className="text-sell">{liq.strength_below ?? "—"}</span></div>
        <div className="flex justify-between border-t border-white/5 pt-2.5">
          <span className="text-mute">Premium / Discount</span>
          <span className={sig?.premium_zone === "Discount" ? "text-buy" : "text-warn"}>
            {sig?.premium_zone ?? "—"} {sig?.premium_pos != null ? `(${sig.premium_pos}%)` : ""}
          </span>
        </div>
      </div>
    </div>
  );
};
